import type { LovOutilFpeDTO, OutilFpeDTO } from '@/features/api/extranet/dto/Demande/OUTILFPE'
import type { ErreurSummaryConfiguration } from '@/features/application/erreur-summary'
import DocumentsContent from '@/features/interface/demande/outilfpe/steps/documents/DocumentsStep.vue'
import EmployeurContent from '@/features/interface/demande/outilfpe/steps/employeur/EmployeurStep.vue'
import PrestationContent from '@/features/interface/demande/outilfpe/steps/prestation/PrestationStep.vue'
import SyntheseContent from '@/features/interface/demande/outilfpe/steps/synthese/SyntheseStep.vue'
import type { SetupDemande } from '@/features/interface/demande/shared/components/demande-content/DemandeContent.types.ts'
import { storeToRefs } from 'pinia'
import { type Component, provide } from 'vue'

import { OUTIL_FPE_ACTIONS, useDemandeOutilFPEActions } from './useDemandeOutilFPEActions.ts'
import { useDemandeOutilFPEStore } from './useDemandeOutilFPEStore.ts'
import type { DemandeStore } from '@/features/interface/demande/shared'

type TabKey = 'Employeur' | 'Prestation' | 'Synthèse' | 'Documents'

const TABS_VUES: Record<TabKey, Component> = {
  Employeur: EmployeurContent,
  Prestation: PrestationContent,
  Synthèse: SyntheseContent,
  Documents: DocumentsContent,
} as const

const TABS_ERR_CONFIG: ErreurSummaryConfiguration<OutilFpeDTO> = {
  Employeur: {
    includeDeep: (state) => [state.employeur],
  },
  Prestation: { includeDeep: (state) => [state.prestation] },
  Synthèse: { include: (state) => [state.commentaire, state.acceptationCg, state.attestationSurHonneur] },
  Documents: {
    includeDeep: (state) => [state.fichiers],
    include: (state) => [state.attestationPiecesJustificatives],
  },
}

function customizeNatureFichiers(store: DemandeStore<'MODEL_OUTIL_FPE', LovOutilFpeDTO>) {
  const { lov } = storeToRefs(store)
  return lov.value.NatureFichier.map((nature) => {
    if (nature.code === 'AttestationEmployeur') {
      return {
        ...nature,
        intitule: "Attestation de l'employeur",
      }
    }
    return nature
  })
}

export const SetupDemandeOutilFPE: SetupDemande<'MODEL_OUTIL_FPE', TabKey> = {
  useStore: useDemandeOutilFPEStore,
  injectActions: () => {
    const actions = useDemandeOutilFPEActions()
    provide(OUTIL_FPE_ACTIONS, actions)
    return actions
  },
  tabFirst: 'Employeur',
  tabsVue: TABS_VUES,
  tabsErrorConfig: () => TABS_ERR_CONFIG,
  customizeNatureFichiers
} as const
